/*
 * Danish page content.
 *
 * Parallel to src/i18n/en/ — every string the page shows, in Danish.
 * Satisfies the same PageContent interface, so the two languages cannot
 * drift apart: a field added to a content interface fails `tsc` here
 * until it is translated.
 *
 * Translation conventions (agreed with the site owner):
 *  - University names use their Danish official names.
 *  - Drafting-style labels are translated (TAVLE 01, SYSTEM KLAR).
 *  - Untranslatables stay: UCloud, Bitten, ISO 27001, EUPL, model names,
 *    "OpenAI-compatible API".
 *  - Danish date format: "14. september 2026" (period after day number).
 */
import type { PageContent } from "../types";
import { hero } from "./hero";
import { logoWall } from "./logoWall";
import { partners } from "./partners";
import { pillars } from "./pillars";
import { worksFor } from "./worksFor";
import { features } from "./features";
import { customizeGrid } from "./customizeGrid";
import { pricing } from "./pricing";
import { resources } from "./resources";
import { faq } from "./faq";
import { finalCta } from "./finalCTA";
import { colophon } from "./colophon";
import { sectionNav } from "./sectionNav";
import { themeToggle } from "./themeToggle";
import { langToggle } from "./langToggle";

export const da: PageContent = {
  hero,
  logoWall,
  partners,
  pillars,
  worksFor,
  features,
  customizeGrid,
  pricing,
  resources,
  faq,
  finalCta,
  colophon,
  sectionNav,
  themeToggle,
  langToggle,
};
